import React from "react";
import { connect } from "react-redux";
import { callService } from "../tools";
import InvitarForm from "./invitar.frm";
import AgregarPolizas from "./AgregarPolizas.cmpt";
import InvitacionEnviada from "./InvitacionEnviada.cmpt";

const mapState = (state) => {
	return {
		listaFamiliares: state.af.listaFamiliares,
		paso: state.af.pasoInvitado,
		uid: state.global.uid,
		tid: state.global.tid,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		pasoInvitado: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO_INVITADO", "pasoInvitado": paso });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		editarFamiliar: (oFamiliar) => {
			dispatch({ "type": "AF_EDITAR_FAMILIAR", "familiar": oFamiliar});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class ModalInvitar extends React.Component {

	existeFamiliar = (nombre, email) => {
		let existe = false;
		this.props.listaFamiliares.map((item) => {
			if(item.email.toLowerCase() == email.toLowerCase()) {
				existe = true;
			}
		});
		return existe;
	}

	submit = (data) => {
		let $this = this;

		if(data.nombre && data.email) {
			$this.props.loader(true);
			let llamaServicio = new callService({
				service: "accesoFamiliar.agregarFamiliar",
				secure: true,
				data: {
					nombre: data.nombre,
					email: data.email
				}
			}).execute().then((respuesta) => {
				console.log("Respuesta", respuesta);
				$this.props.editarFamiliar({id: respuesta.key, email: respuesta.email, polizas: []});
				$this.props.pasoInvitado(1);
				$this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_AGREGAR-CORRECTOS", "dispositivo": $this.props.dispositivo });
				$this.props.loader(false);
			}).catch((error) => {
				console.log("error", error);
				$this.props.loader(false);
				this.props.alerta(error.message.mensaje);
			});	
		}
	}

	render() {
		return (
			<div>
				{ this.props.paso == 0 &&
					<InvitarForm onSubmit={this.submit} />
				}
				{ this.props.paso == 1 &&
					<AgregarPolizas />
				}
				{ this.props.paso == 2 &&
					<InvitacionEnviada />
				}
			</div>
		);
	}	
	
}

export default connect(mapState, mapDispatch)(ModalInvitar);


// WEBPACK FOOTER //
// ./src/acceso-familiar/modalInvitar.cmpt.js